<template>
    <div class="col backgroundForm">
        <h3 clas="col" align="center">Datos y Firma del Director</h3>
        
        <nav class="nav nav-pills nav-justified" id="nav-tab" role="tablist">
            
                <a class="nav-item nav-link active" id="nav-init-traffic" data-toggle="tab" href="#nav-init" role="tab" aria-controls="nav-home" aria-selected="true">1. Datos y Firma <font-awesome-icon icon="user-plus" /></a>
                <a class="nav-item nav-link" id="nav-second-traffic" data-toggle="tab" href="#nav-second" role="tab" aria-controls="nav-profile" aria-selected="false" >2. Baja de Firma <font-awesome-icon icon="user-minus" /></a>
                <a class="nav-item nav-link" id="nav-tirdh-traffic" data-toggle="tab" href="#nav-tirdh" role="tab" aria-controls="nav-profile" aria-selected="false" >3. Vista Previa Firma <font-awesome-icon icon="file-pdf" /></a>
        
        </nav>

          <div class="tab-content" id="nav-tabContent">
                <br>            
                <div class="tab-pane fade show active"  id="nav-init" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="alert alert-warning col-12 col-md-8 offset-md-2">La imagen a subir debe ser de extension <b>.PNG</b> con transparencia "Sin fondo", debe ser de una medida de <b>1000 (ancho) x 676(alto).</b></div>
                <div class="row">
                    <div class="col-12 col-sm-6">               
                        <div class="col">

                            <div class="col">
                                <div class="form-group">
                                    <label for="recipient-name" class="col-form-label" v-if="cSessionUser.roleAssign !== 'OPERADOR CAPITANIA'">Gestion</label>
                                    <select name="" id="" class="form-control" v-model="year_select" >
                                        <option v-for="ye in years" :key="ye.c" :value="ye.c">{{ ye.c }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col">
                            <label for="title">Busqueda Persona</label>
                            <vue-bootstrap-typeahead                            
                                class="col-12"
                                v-model="persons"
                                :data="persons_list"
                                size="sm"
                                :serializer="item => (`${item.grade} ${item.speciality} ${item.complete}`)"
                                @hit="mSelectPerson"
                                :placeholder="'Busqueda Director'"                                        
                            />
                        </div>

                        <div class="form-group col" v-if="director_select.id > 0">
                            <label for="title">Director Seleccionado</label>
                            <input type="text" name="director_select" id="director_select" class="form-control-plaintext alert alert-success" readonly v-model="director_select.complete">                        
                        </div>
                        
                    </div>
                    <div align="center" class="col-12 col-sm-6" id="imageShip">
                        <image-uploader
                        :preview="true"
                        :className="['fileinput' ,{ 'fileinput--loaded': hasImage }]"
                        capture="environment"
                        :debug="1"
                        doNotResize="gif"
                        :scaleRatio="scaleImage"
                        :quality="qualityImage"
                        :autoRotate="true"
                        outputFormat="verbose"
                        @input="setImage"
                    >
                    
                        <label for="fileInput" slot="upload-label" class="col">
                        <div><font-awesome-icon icon="camera-retro" size="3x"></font-awesome-icon></div>
                        <span class="upload-caption">{{
                            hasImage ? "Cambiar" : "Seleccionar Foto Firma"
                        }}</span>
                        </label>
                        </image-uploader>
                    </div>
                </div>       
                <div align="center">
                    <transition name="fade">
                    <button class="btn btn-outline-primary" @click="sendFirmDirector" v-if="btnUp">Subir <font-awesome-icon icon="upload" ></font-awesome-icon></button>
                    </transition>
                </div>
            </div>
            <!-- end first tab -->

            <div class="tab-pane fade show"  id="nav-second" role="tabpanel" aria-labelledby="nav-home-tab">
                

                <div align="center">
                    <transition name="fade">
                    <button class="btn btn-outline-primary" @click="mGetDtsFirm">Ver <font-awesome-icon icon="eye" ></font-awesome-icon></button>
                    </transition>
                </div>

                <!-- aca mostramos las fotos de la capitania -->
                <br>
                <div class="alert alert-success col-12 col-md-6 offset-md-3" v-if="firm_vigent.id > 0" align="center">
                    {{ firm_vigent.complete }}<br>
                    <button class="btn btn-danger" @click="mLowFirm">Baja de Firma <font-awesome-icon icon="arrow-circle-down" ></font-awesome-icon></button>
                </div>

            </div>
            <!-- end second tab -->

            <div class="tab-pane fade show"  id="nav-tirdh" role="tabpanel" aria-labelledby="nav-tirdth-tab">
                <div class="alert alert-warning col-12 col-md-8 offset-md-2">Vista previa de la firma en el certificado</div>
                <button class="btn btn-outline-danger col-12 col-md-4 offset-md-4" @click="mModelFirm">Vista Impresion Certificado <font-awesome-icon icon="file-pdf" ></font-awesome-icon></button>
            </div>

        </div>    

    <modal-loading :id-modal="idModalL" :title="modalLoadTitle" :status-send="sendRequest" ></modal-loading>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';

import modalLoading from '../modal/modalLoading';

const qs= require('qs');

export default {
    name:'upload-photo-captain',
    data(){
        return{
            firm_vigent:{
                id:0,
                complete:null
            },
            idModalL:'upLoading',
            modalLoadTitle:'Subiendo...',
            sendRequest:true,
            title:'Firma Director',
            hasImage:false,
            scaleImage:0.5,
            qualityImage:0.9,            
            bImages:[],
            years:[],
            year_select:0,
            firm_photo:{
                id:'',
                image:null
            },
            persons:null,
            persons_list:[],
            director_select:{
                id:0,
                complete:null
            }
        }
    },
    mounted(){
        $('.carousel').carousel({
            pause:true
        });
        // this.callCaptains();
        this.getYears();
    },
    methods:{
        mModelFirm(){
            console.log('mandando a imprimir el modelo de la firma del director');
            
            let url_report=btoa(`pdfEnrollmentTest`);
            let route = this.$router.resolve({path: `/report/${url_report}`});
            
            window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
        },
        getYears(){
            let ya=new Date();
            this.year_select=ya.getFullYear();
            const init=2018;
            this.years=[];
            for(let i=init; i<=this.year_select; i++){
                let ai={c:i};
                this.years.push(ai);
            }
        },
        mChangeCaptain(){
            this.bImages=[];
        },
        setImage(output){
            this.hasImage=true;
            this.firm_photo.image=output.dataUrl;
            
            // console.log(this.ship.image);
        },
        async mLowFirm(iphoto){
            if(iphoto.id!==0){
            // enviamos al servidor la peticion de dar de baja a la fotografia
                let message = {
                        title: 'Baja Firma ',
                        body: `¿Desea dar de Baja la firma Vigente del <b>${this.firm_vigent.complete}</b>?`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            this.mShowModalUP(this.idModalL);
                            try {
                                let d_firm=await axios.get(`downFirmCaptain/${this.firm_vigent.id}?api_token=${Vue.auth.getToken()}`);

                                // console.log(d_firm);
                                if(d_firm.data[0].status){
                                    toastr.success(d_firm.data[0].respuesta, 'Exito');
                                    this.mGetDtsFirm();
                                }else{
                                    toastr.error(d_firm.data[0].respuesta, 'Error');
                                }

                            } catch (error) {
                                console.log(error)   
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error P-01')
                                    this.mCloseModalUP(this.idModalL);                                
                                }, 3000)
                            }
                            
                            setTimeout(()=>{                
                                this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })                  
            }else{
                console.log('este archivo no puede ser dado de baja')
            }
        },
        mValidateFormImage(){
            
            if(this.year_select===0){
                toastr.warning('Seleccione la gestion correspondiente', 'Gestion');
                return false;
            }

            if(this.cSessionUser.roleAssign === 'OPERADOR CAPITANIA' ){
                
                toastr.warning('No tiene autorizacion para cargar firmas', 'Firma Director');
                return false;
            }            

            if( !(this.director_select.id !== 0 ) ){
                toastr.warning('Busque y seleccione al Director', 'Advertencia');
                return false
            }
            return true;
        },
        sendFirmDirector(){
            if(this.mValidateFormImage()){
                // colocamamos el mensaje de que si queremos subir la fotografia
                let message = {
                        title: 'Cargar Fotografia',
                        body: `¿Desea Registrar la fotografia de la firma del Director <b>${this.director_select.complete}</b>?`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            this.mShowModalUP(this.idModalL);
                            try {                                
                                let sa={
                                    id_person:this.director_select.id,
                                    image:this.firm_photo.image,
                                    complete:this.director_select.complete,
                                    year_d:this.year_select
                                }
                                    // let fu= await axios.post(`upPhotoShip`, qs.stringify(sa));
                                let fd= await axios.post(`upPhotoFirmDirector?api_token=${Vue.auth.getToken()}`, qs.stringify(sa));
                                    
                                if(fd.data[0].status){
                                    toastr.success(fd.data[0].respuesta, 'Exito');
                                    this.firm_photo.image=null;
                                    this.hasImage=false;
                                    document.getElementsByClassName('img-preview')[0].src=null;
                                    this.director_select.id=0;
                                    this.director_select.complete=null; 
                                }else{
                                    toastr.error(fd.data[0].respuesta, 'Error');
                                }

                                                           

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error P-01')
                                    this.mCloseModalUP(this.idModalL);                                
                                }, 3000)
                            }

                            setTimeout(()=>{                
                                        this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })
            }else{
                console.log('no se enviara la imagen')
            }                
        },
        mViewSearch(event){
            var radios=$("input[type=radio]").parents('label');
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            //console.log(radioV);
            this.optionSearch=radioV;
        },
        async mGetDtsFirm() {
            // obtenemos los datos del Director
            this.firm_vigent.id=0;
            try {
                this.bImages = [];
                let ext;

                let dts = await axios.get(`getDtsFirmDirector?api_token=${Vue.auth.getToken()}`);
                console.log(dts);
                if(dts.data.length > 0){
                    this.firm_vigent.id=dts.data[0].id;
                    this.firm_vigent.complete=dts.data[0].name_director;
                }else{
                    toastr.warning('No existe una firma autorizada', 'Error');
                }
                
            } catch (error) {
                console.error(error);
            }
        },
        mShowModalUP(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalUP(idM){
            $('#'+idM).modal('hide');
        },
        mSelectPerson(data){
            // console.log(data);
            this.director_select.id=data.id;
            this.director_select.complete=`${data.grade} ${data.speciality} ${data.complete.toLowerCase()}`;
        }
    },
    computed:{
        btnUp(){
            if(this.firm_photo.image !== null)
                return true;
            else
                return false;
        },
        viewSearch(){
            switch(this.optionSearch){
                case 'name':
                    this.vSearch=true;
                break;

                case 'enrollment':
                    this.vSearch=false;
                break;
            }
            return this.vSearch;
        },
        cSessionUser(){
            return this.$store.getters.getUserState;
        }
    },
    watch:{
        persons(newPerson){
            axios.get(`searchPerson/${newPerson}?api_token=${Vue.auth.getToken()}`)
            .then((res)=>{
                // console.log(res);
                this.persons_list=res.data;
            }).catch(err=>{
                console.log(err);
            })
        },
        query(newQuery) {
            
            axios.get(`searchShipPhotoWeb/${this.optionSearch}/${newQuery}/${this.cSessionUser.portId}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    
                    this.boatsEnrollment = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })               
        }
    },
    components:{
        'modal-loading':modalLoading
    }
}
</script>

<style>
#imageShip img{
    width: 250px;
}

#fileInput {
  display: none;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.my-8 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}

</style>



// WEBPACK FOOTER //
// src/components/matriculacion/UploadFirmDirector.vue